import { render, staticRenderFns } from "./Codegame.vue?vue&type=template&id=81c02c92&"
import script from "./Codegame.vue?vue&type=script&lang=js&"
export * from "./Codegame.vue?vue&type=script&lang=js&"
import style0 from "./Codegame.vue?vue&type=style&index=0&id=81c02c92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports